import React from "react";

const abbr = (day) => day.slice(0, 3);
const compact = (v) => v.replace(/\s*[–-]\s*/g, "–");

// Uniform weekday + hours list: abbreviated day, hours on the same line.
export function HoursList({ hours = [], dayClass = "", valueClass = "", rowClass = "", testid = "hours-list" }) {
  return (
    <dl className="w-full" data-testid={testid}>
      {hours.map((h) => (
        <div key={h.day} className={`grid grid-cols-[3rem_1fr] items-baseline gap-3 py-1 text-[13px] tabular-nums whitespace-nowrap ${rowClass}`}>
          <dt className={`uppercase tracking-[0.12em] text-xs ${dayClass}`}>{abbr(h.day)}</dt>
          <dd className={`text-right ${valueClass}`}>{compact(h.value)}</dd>
        </div>
      ))}
    </dl>
  );
}
